<template>
  <div>
    <div class="banner innerpageBanner">
<div class="container">
<div class="caption">
<div><h1>关于勃艮第</h1>
<p>勃艮第详细介绍</p>
</div>
</div>
</div>

<img src="https://image.insideburgundy.cn/insideburgundy/20190523/7e517bac99c145cd92d05451023f9502.png" alt="有关勃艮第"  class="cover-image">
</div>

    <div class="container">
      <searchBox  />
      <div class="breadcrumbWrap">
        <div class="breadcrumb" style="padding-top:20px">
            <span property="itemListElement" typeof="ListItem">
              <a
                property="item"
                typeof="WebPage"
                title="Go to Jasper Morris Inside Burgundy."
                href="#/"
                class="home"
              >
                <span property="name">首页</span>
              </a>
              <meta property="position" content="1">
            </span> /
          <span property="itemListElement" typeof="ListItem">
              <span property="name">关于勃艮第</span>
              <meta property="position" content="2">
            </span>
        </div>
      </div>
    </div>

    <div class="container">
      <div class="entry">
        <h3 style="padding-bottom: 20px;padding-top: 20px;">有关勃艮第</h3>
        <p class="p1">勃艮第在人类历史上一直有显著的地位，从公元5世纪开始一个叫“勃艮“的部落来到法国并驻扎到这里，到一千年后勃艮第公国成为欧陆最富有的王国，再到今天出产伟大葡萄酒的勃艮第产区。</p>
        <p class="p1">
          <span
            class="s1"
          >法语中勃艮第被称作Bourgogne，法语的名词是分阴阳性的，阴性的La Bourgogne指的是勃艮第地区，而阳性的Le Bourgogne专指勃艮第的葡萄酒，我们的网站主要是关于后者的内容。</span>
        </p>
        <p class="p1">
          <span
            class="s1"
          >勃艮第看起来非常简单，它主要由两个葡萄品种构成：单一的白葡萄品种霞多丽（Chardonnay），和单一的红葡萄品种黑皮诺（Pinot Noir)，但是实践告诉我们，勃艮第远不止如此简单。</span>
        </p>
        <p class="p1">
          <span
            class="s1"
          >简而言之，勃艮第葡萄酒的一切都和种植葡萄的土地息息相关，但同时勃艮第的酒农也发挥着重要的作用。伟大的葡萄酒总是可以让你感受到出产这款酒的土地特征，想想勃艮第葡萄酒的级别：从村级园到一级园再到特级园，不同的土地上产出的葡萄酒是那样的风格迥异。除此之外，勃艮第葡萄酒总能让你感受到葡萄局中人性的一面，这里的人性倒不是说酒农所采用的酿造技术，而是酒农本人的脾气和秉性。</span>
        </p>
        <p class="p1">
          <span class="s1">
            勃艮第有太多的酒可以选择了！也正是处于这样的原因，为了给勃艮第爱好者一个明确的方向，我们创建了<b>Inside Burgundy</b>的网站。
          </span>
        </p>
        <h4 style="padding-bottom: 15px;">
          <span class="s1">勃艮第子产区（由北向南）</span>
        </h4>
        <ul class="ul1">
          <li class="li1">
            <span class="s1">夏布利</span>
          </li>
          <li class="li1">
            <span class="s1">夜丘</span>
          </li>
          <li class="li1">
            <span class="s1">伯恩丘</span>
          </li>
          <li class="li1">
            <span class="s1">沙隆内丘</span>
          </li>
          <li class="li1">
            <span class="s1">马孔</span>
          </li>
        </ul>
        <h4 style="padding-bottom: 15px;">
          <span class="s1">勃艮第产区级别</span>
        </h4>
        <ul>
          <li class="p1">
            <span class="s1">特级园</span>
          </li>
          <li class="p1">
            <span class="s1">一级园</span>
          </li>
          <li class="p1">
            <span class="s1">村级园</span>
          </li>
          <li class="p1">
            <span class="s1">大区级</span>
          </li>
        </ul>
        <h4 style="padding-bottom: 15px;">
          <span class="s1">勃艮第产区数据</span>
        </h4>
        <ul>
          <li class="p1">
            <span class="s1">包含84个AOC产区</span>
          </li>
          <li class="p1">
            <span class="s1">29000公顷（仅占法国葡萄园种植面积的6%）</span>
          </li>
          <li class="p1">
            <span class="s1">平均年产量1.34亿升 （约等于年产1500万箱葡萄酒）</span>
          </li>
          <li class="p1">
            <span class="s1">勃艮第产区白葡萄酒产量约占宗产量61%，红葡萄酒占总产量28%，起泡酒占11%</span>
          </li>
        </ul>
      </div>
    </div>
    <div class="container">
      <div class="gridBoxes four">
        <h2 class="animate fadeInUp triggeredCSS3">最新资讯</h2>
        <ul>
          <li class="animate fadeInUp triggeredCSS3" v-for="item in newlatest" :key='item.id'>
            <div class="content">
              <a :href="`#/latestinformation?id=${item.id}`">
                <div class="img">
                  <img
                    :src="item.image"
                    alt="Frost Patrol: Sunday April 14th"
                    class="cover-image"
                  >
                </div>
              </a>
              <div class="discription">
                <h6>
                  <a :href="`#/latestinformation?id=${item.id}`">
                    {{item.title}}
                  </a>
                </h6>
                {{item.introduction}}
              </div>
              <a :href="`#/latestinformation?id=${item.id}`" class="readmore">阅读更多</a>
            </div>
          </li>

        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import searchBox from '../template/search';
import ajax from '../ajax'

export default {
  data(){
    return {
      newlatest:[]
    }
  },
  components:{
    searchBox
  },
  created() {
    this.getNewlatest()
  },
  methods: {
    getNewlatest(){
      ajax.getNewsLatest().then(res=>{
        this.newlatest = res.data
      })
    },
    hreftwo() {
      this.$router.push({ path: "./insideburgundy" });
    },
    changeActive($event) {
      $event.currentTarget.style = "border-bottom: 4px solid #990033;";
    },
    removeActive($event) {
      $event.currentTarget.style = "";
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Burgundy.vue